import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { servicios_grupogack_catalogo, nivel_escolaridad } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService';
import DataTableService from '../../../DataTableService/DataTableService';
import SpinnerOval from '../../../../../../Services/Spinner/SpinnerOval';

const NivelEscolaridad = ({ id, permisos }) => {

    const [nivelEscolaridad, setNivelEscolaridad] = useState(null);

    useEffect(() => {
        Axios.get(`${servicios_grupogack_catalogo}/tipoEscolaridad`, headersAuth())
        .then(res => {
            switch(res.data.status) {
                case 200:
                    setNivelEscolaridad(res.data.dataResponse);
                    break;
                case 404:
                    setNivelEscolaridad([]);
                    break;
                default:
                    alert('error');
                    break;
            }
        })
        .catch(error => alert('error'));
    },[]);

    return (
        <div id={ id }>
            {   
                nivelEscolaridad
                ?   <DataTableService id={id} title={ nivel_escolaridad }
                        columns={[
                            { field: "escolaridadNom", title: "Nombre" }
                        ]}
                        data={nivelEscolaridad}
                        permisos={permisos}
                    />
                :   <SpinnerOval />
            }
        </div>
    );
}
 
export default NivelEscolaridad;
